module.exports = __webpack_public_path__ + "img/noData.25035e14.png";